var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
(function () {
    angular.module('QMC.Nachrichten', ['QMC.Klient']).config(routes).filter('renderHTMLCorrectly', function ($sce) { return function (stringToParse) {
        return $sce.trustAsHtml(stringToParse);
    }; });
    routes.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider', 'qmcBase'];
    function routes($locationProvider, $stateProvider, $urlRouterProvider, qmcBase) {
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
        $stateProvider
            .state('mailbox', {
            url: '/mailbox?:folderId:messageId',
            templateUrl: qmcBase + '/Nachrichten',
            controller: 'NachrichtenController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Mailbox');
                    }]
            }
        });
    }
})();
var QMC;
(function (QMC) {
    var InternalMessage;
    (function (InternalMessage) {
        var HttpProvider = /** @class */ (function () {
            function HttpProvider() {
            }
            HttpProvider.configureHttpProvider = function ($httpProvider) {
                // initialize get if not there
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};
                }
                // disable IE ajax request caching
                $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                // extra
                $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            };
            return HttpProvider;
        }());
        InternalMessage.HttpProvider = HttpProvider;
    })(InternalMessage = QMC.InternalMessage || (QMC.InternalMessage = {}));
})(QMC || (QMC = {}));
(function () {
    angular.module('QMC.Nachrichten')
        .config(['$httpProvider', QMC.InternalMessage.HttpProvider.configureHttpProvider]);
})();
var QMC;
(function (QMC) {
    var InternalMessage;
    (function (InternalMessage) {
        var NachrichtenService = /** @class */ (function (_super) {
            __extends(NachrichtenService, _super);
            function NachrichtenService($http, $q) {
                var _this = _super.call(this, $http, $q) || this;
                _this.$http = $http;
                _this.$q = $q;
                _this.modulePath = '/InternalMessage';
                return _this;
            }
            NachrichtenService.prototype.getMessageList = function (dateFrom, dateTo, folderId, page, pageSize) {
                return _super.prototype.getPagination.call(this, this.modulePath, { folderId: folderId, page: page, pageSize: pageSize, dateFrom: dateFrom, dateTo: dateTo }, function (data) {
                    return data;
                });
            };
            NachrichtenService.prototype.getMessage = function (id) {
                return _super.prototype.getItem.call(this, this.modulePath + '/' + id, {}, function (data) {
                    return data;
                });
            };
            NachrichtenService.prototype.getFolderList = function () {
                return _super.prototype.get.call(this, this.modulePath + '/Folder', {}, function (data) {
                    return data;
                });
            };
            NachrichtenService.prototype.getUnreadCount = function () {
                return _super.prototype.get.call(this, this.modulePath + '/UnreadCount', {}, function (data) {
                    return data;
                });
            };
            /**
             * Downloads one or more attachments of a message. If attachmentId is not set, it downloads all attachments of the message as a zip file.
             * @param messageId The object id of the message.
             * @param attachmentId The id of the attachment. If not set, all attachments will be downloaded as a zip file.
             */
            NachrichtenService.prototype.downloadAttachment = function (messageId, attachmentId) {
                return _super.prototype.getItem.call(this, this.modulePath + '/' + messageId + '/Attachment', { attachmentId: attachmentId }).then(function (data) {
                    return data.base64;
                });
            };
            NachrichtenService.prototype.getAvailableRecipients = function () {
                return _super.prototype.get.call(this, this.modulePath + '/AvailableRecipients', {}, function (data) {
                    return data;
                });
            };
            NachrichtenService.prototype.getRecipientList = function (id) {
                return _super.prototype.get.call(this, this.modulePath + '/' + id + '/Recipient', {}, function (data) {
                    return data;
                });
            };
            NachrichtenService.prototype.postMessage = function (data) {
                return _super.prototype.post.call(this, this.modulePath, data).then(function (e) {
                    return e;
                });
            };
            NachrichtenService.prototype.deleteMessage = function (id, deleteFromSend) {
                if (deleteFromSend === void 0) { deleteFromSend = false; }
                return _super.prototype.delete.call(this, this.modulePath + '/' + id + '?deleteFromSendFolder=' + deleteFromSend).then(function (data) {
                    return data;
                });
            };
            NachrichtenService.prototype.markMessageAsRead = function (request) {
                return _super.prototype.put.call(this, this.modulePath + '/MarkAsRead', request).then(function (data) {
                    return data;
                });
            };
            NachrichtenService.prototype.moveMessageToFolder = function (request) {
                return _super.prototype.put.call(this, this.modulePath + '/MoveToFolder', request).then(function (data) {
                    return data;
                });
            };
            NachrichtenService.prototype.moveMessageToRecycleBin = function (request) {
                _super.prototype.put.call(this, this.modulePath + '/MoveToRecycleBin', request);
            };
            NachrichtenService.prototype.postFolder = function (data) {
                return _super.prototype.post.call(this, this.modulePath + '/Folder', data).then(function (e) {
                    return e;
                });
            };
            NachrichtenService.prototype.putFolder = function (id, data) {
                return _super.prototype.put.call(this, this.modulePath + '/Folder/' + id, data).then(function (e) {
                    return e;
                });
            };
            NachrichtenService.prototype.deleteFolder = function (id) {
                return _super.prototype.delete.call(this, this.modulePath + '/Folder/' + id).then(function (e) {
                    return e;
                });
            };
            //Draft
            NachrichtenService.prototype.getDrafts = function () {
                return _super.prototype.get.call(this, this.modulePath + '/Draft', {}, function (data) {
                    data.forEach(function (x) {
                        x.content = JSON.parse(x.content);
                        x.content.recipientIds = x.content.recipientIds ? x.content.recipientIds : [];
                        x.lastUpdate = x.lastUpdate ? moment(x.lastUpdate).toDate() : new Date();
                    });
                    return data;
                });
            };
            NachrichtenService.prototype.postDraft = function (dataOriginal) {
                var data = angular.copy(dataOriginal);
                data.content = JSON.stringify(data.content);
                return _super.prototype.post.call(this, this.modulePath + '/Draft', data).then(function (e) {
                    return e.createdObjectId;
                });
            };
            NachrichtenService.prototype.putDraft = function (id, dataOriginal) {
                var data = angular.copy(dataOriginal);
                data.content = JSON.stringify(data.content);
                return _super.prototype.put.call(this, this.modulePath + '/Draft/' + id, data).then(function (e) {
                    return e;
                });
            };
            NachrichtenService.prototype.deleteDraft = function (id) {
                return _super.prototype.delete.call(this, this.modulePath + '/Draft/' + id).then(function (e) {
                    return e;
                });
            };
            NachrichtenService = __decorate([
                QMC.Service('QMC.Nachrichten', 'NachrichtenService'),
                QMC.Inject('$http', '$q')
            ], NachrichtenService);
            return NachrichtenService;
        }(QMC.Common.BaseService));
        InternalMessage.NachrichtenService = NachrichtenService;
    })(InternalMessage = QMC.InternalMessage || (QMC.InternalMessage = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var InternalMessage;
    (function (InternalMessage) {
        var NachrichtenController = /** @class */ (function () {
            function NachrichtenController($location, nachrichtenService, $qui, $stateParams, $state, $scope, lng, userService) {
                var _this = this;
                this.$location = $location;
                this.nachrichtenService = nachrichtenService;
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.$state = $state;
                this.$scope = $scope;
                this.lng = lng;
                this.userService = userService;
                // tslint:disable-next-line:no-unused-variable
                this.ui = new QMC.InternalMessage.UserInterface();
                this.folderFormCreateState = "new";
                this.folderFormUpdateState = "edit";
                this.selectedMessageIds = [];
                this.selectedFileNames = [];
                this.uploads = [];
                this.inboxFolderId = QMC.Common.Constants.MESSAGE_INBOX_FOLDER_ID;
                this.sentFolderId = QMC.Common.Constants.MESSAGE_SENT_FOLDER_ID;
                this.recycleBinFolderId = QMC.Common.Constants.MESSAGE_RECYCLEBIN_FOLDER_ID;
                this.forwardRecipients = [];
                this.useTrash = true;
                this.daysToPast = 0;
                this.summernoteOptions = {
                    height: 350,
                    focus: true,
                    airMode: false,
                    lang: 'de-DE',
                    toolbar: [
                        ['font', ['bold', 'italic', 'underline', 'clear']],
                        ['alignment', ['ul', 'ol']]
                    ],
                    callbacks: { onChange: function () {
                            var args = [];
                            for (var _i = 0; _i < arguments.length; _i++) {
                                args[_i] = arguments[_i];
                            }
                            _this.onSummernoteChange(args[0], $(args[1][0]));
                        } }
                };
                this.recs = [];
                this.readMode = true;
                this.drafts = [];
                this.draftFolderId = '00000000-0000-0000-0000-000000000005';
                /**
                 * setFilterView
                 * @description Set FilterList spaceing.
                 */
                this.selectedFilter = null;
                this.checkToggle = true;
                this.selectedRecs = [];
                this.isDraftPosting = false;
                $qui.init($qui.getSectionColor($location.path()), function () {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    setTimeout(function () {
                        if (QMC.Common.Constants.IS_MOBILE) {
                            $("#page-wrapper").addClass("notification");
                            $(window).unbind("scroll");
                            $("body").css("overflow-y", "hidden");
                            $scope.$on("$destroy", function () {
                                $("#page-wrapper").removeClass("notification");
                            });
                        }
                    }, 500);
                });
                this.isInit = true;
                this.reply = false;
                this.replyToAll = false;
                this.folderLoading = true;
                if (document.getElementById("permissions").getAttribute("message").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module message");
                    this.forbidden = true;
                    return;
                }
                this.init();
                this.resetMessageList();
                this.resetNewForm();
                this.getFolders();
                this.userService.getUserSettings(["INTERNENACHRICHTEN.USETRASH", "INTERNENACHRICHTEN.ANZEIGEANZAHLTAGE"], false).then(function (data) {
                    _this.useTrash = data[0].value.toLowerCase().trim() === "true" || data[0].value.toLowerCase().trim() === "";
                    _this.daysToPast = parseInt(data[1].value);
                    if (_this.daysToPast > 0) {
                        var temp = new Date();
                        temp.setDate(temp.getDate() - _this.daysToPast);
                        _this.filter.filterDateFrom = temp;
                        _this.filter.dateFrom.setDate = temp;
                    }
                    _this.setFilter();
                });
                this.promptOptionsFolderDelete = {
                    title: this.lng.translate(21004023, "Ordner"),
                    icon: "qm-icon-folder",
                    yesNo: true,
                    id: "prompt-folder-delete",
                    text: this.lng.translate(21004043, 'Wollen Sie den ausgewählten Ordner mit allen Unterordnern wirklich löschen?')
                };
                setTimeout(function () {
                    $('#' + _this.selectedFolderId).addClass('active-folder');
                }, 500);
                this.getAvailableRecipients();
            }
            NachrichtenController.prototype.onSummernoteChange = function (content, element) {
                // check for parent
                if (element.closest('#summernoteNewMessage').length > 0) { //newMode
                    this.newMessageDraft(content);
                }
                if (element.closest('#summernoteAnswerMessage').length > 0) { //answerMode
                    this.replyMessageDraft(content);
                }
                if (element.closest('#summernoteForwardMessage').length > 0) { //forwardMode
                    this.forwardMessageDraft(content);
                }
            };
            /**
             *  init
             *  @description Init the filter
             */
            NachrichtenController.prototype.init = function () {
                var _this = this;
                $('#summernoteNewMessage .summernote').summernote(this.summernoteOptions);
                $('#summernoteAnswerMessage .summernote').summernote(this.summernoteOptions);
                $('#summernoteForwardMessage .summernote').summernote(this.summernoteOptions);
                this.filter = {
                    dateFrom: moment().subtract(3, 'months').toDate(),
                    dateTo: new Date(),
                    filterDateFrom: moment().subtract(3, 'months').toDate(),
                    filterDateTo: new Date()
                };
                this.folderFormCreate = {
                    name: '',
                    parentFolderId: null,
                    order: 0,
                };
                this.folderFormUpdate = {
                    name: '',
                    parentFolderId: null,
                    order: 0,
                };
                //calculate postbox height
                if (!QMC.Common.Constants.IS_MOBILE) {
                    $(window).resize(function () { $('#folderList').height($('#folderPane').height() - 190); });
                    $('#folderList').height($('#folderPane').height() - 190);
                }
                this.$scope.$watch('vm.newForm', function (newVal, oldVal) {
                    if (newVal !== oldVal && newVal)
                        _this.newMessageDraft($('#summernoteNewMessage').find('.note-editable').html());
                }, true);
                this.$scope.$watch('vm.forwardRecipients', function (newVal, oldVal) {
                    if (newVal !== oldVal && newVal && newVal.length !== oldVal.length)
                        _this.forwardMessageDraft($('#summernoteForwardMessage').find('.note-editable').html());
                });
            };
            NachrichtenController.prototype.setFilterView = function (filter, px) {
                var _this = this;
                this.transferFolder = null;
                $("[data-filter]").fadeOut("fast");
                if (filter === this.selectedFilter || filter === 'hide') {
                    this.filterHeight = 0;
                    this.selectedFilter = null;
                    $(".scroll-container").css("top", 56);
                    $("[data-filter]").fadeOut("fast");
                }
                else {
                    this.selectedFilter = filter;
                    if (this.filterHeight > 0) {
                        $(".scroll-container").css("top", 56);
                        setTimeout(function () {
                            $(".scroll-container").css("top", px);
                            $("[data-filter='" + filter + "']").fadeIn("fast");
                            _this.filterHeight = px;
                        }, 500);
                    }
                    else {
                        $("[data-filter='" + filter + "']").fadeIn("fast");
                        $(".scroll-container").css("top", px);
                        this.filterHeight = px;
                    }
                }
            };
            /**
             * setFilter
             * @description Set the current filter values
             */
            NachrichtenController.prototype.setFilter = function () {
                this.filter = {
                    filterDateFrom: this.filter.filterDateFrom,
                    filterDateTo: this.filter.filterDateTo,
                    dateFrom: this.filter.filterDateFrom,
                    dateTo: this.filter.filterDateTo
                };
                this.getMessagesOfCurrentFolder();
            };
            NachrichtenController.prototype.toggleAllCheckboxes = function () {
                console.log(this.messageList.items);
                for (var msg in this.messageList.items)
                    this.messageList.items[msg].isSelected = this.checkToggle;
                this.checkToggle = !this.checkToggle;
                this.getSelectedMessages();
            };
            NachrichtenController.prototype.getSelectedMessages = function () {
                var areMessSelected = false;
                var messageIds = [];
                for (var i = 0; i < this.messageList.items.length; i++) {
                    if (this.messageList.items[i].isSelected) {
                        messageIds.push(this.messageList.items[i].messageObjectId);
                        areMessSelected = true;
                    }
                }
                if (!areMessSelected) {
                    this.setFilterView('hide', 140);
                }
                this.selectedMessageIds = messageIds;
                this.$qui.scopeApply(this.$scope);
            };
            NachrichtenController.prototype.changeFolder = function (folder) {
                this.setFilterView('hide', 140);
                $('#' + this.selectedFolderId).removeClass('active-folder');
                this.selectedMessageIds = [];
                this.folderLoading = true;
                this.shownMessage = null;
                this.isNewMessage = false;
                this.selectedFolder = folder;
                this.selectedFolderId = folder.id;
                this.selectedFolderName = folder.caption;
                this.getMessagesOfCurrentFolder();
                this.reply = false;
                this.replyToAll = false;
                this.reply = false;
                this.folderFormUpdateState = 'edit';
                this.folderFormUpdate = {
                    name: this.selectedFolder.caption,
                    parentFolderId: this.selectedFolder.parentObjectId,
                    order: this.selectedFolder.order,
                };
                if (this.selectedFolderId !== this.draftFolderId)
                    this.ui.createFolderUpdateForm();
                this.isSendFolder = this.selectedFolderId === QMC.Common.Constants.MESSAGE_SENT_FOLDER_ID;
                $('#' + this.selectedFolderId).addClass('active-folder');
            };
            NachrichtenController.prototype.fileTypeIcon = function (fileName) {
                var type = fileName.split('.')[fileName.split('.').length - 1];
                var icon = "fa fa-";
                switch (type) {
                    case ('jpg'):
                    case ('gif'):
                    case ('png'):
                        icon += "file-image-o";
                        break;
                    case ('txt'):
                        icon += "file-txt-o";
                        break;
                    case ('xdoc'):
                    case ('doc'):
                        icon += "file-word-o";
                        break;
                    case ('zip'):
                    case ('rar'):
                        icon += "file-zip-o";
                        break;
                    case ('pdf'):
                        icon += "file-pdf-o";
                        break;
                    case ('csv'):
                    case ('xlxs'):
                        icon += "file-excel-o";
                        break;
                    case ('xppt'):
                    case ('ppt'):
                        icon += "file-powerpoint-o";
                        break;
                    default:
                        icon += "file-o";
                }
                return icon;
            };
            NachrichtenController.prototype.recSelect = function () {
                this.selectedRecs = [];
                this.newForm.recipientIds = [];
                for (var select in this.recs)
                    if (this.recs[select].isSelected) {
                        this.newForm.recipientIds.push(this.recs[select].objectId);
                        this.selectedRecs.push(this.recs[select]);
                    }
                this.$qui.bindEvents();
            };
            NachrichtenController.prototype.showMessage = function (id) {
                var _this = this;
                if (this.selectedFolderId === this.draftFolderId) {
                    this.openDraft(id);
                    return;
                }
                $('#summernoteAnswerMessage').find('.note-editable').html('');
                this.loading = true;
                this.reply = false;
                this.forward = false;
                this.nachrichtenService.getMessage(id).then(function (data) {
                    _this.shownMessage = data;
                    _this.markShownMessageAsRead();
                    $('#summernoteAnswerMessage').find('.note-editable').html(_this.getAnswerString(data));
                    $('#summernoteForwardMessage').find('.note-editable').html(_this.getAnswerString(data));
                    _this.loading = false;
                    setTimeout(_this.$qui.initTooltip, 600);
                });
            };
            NachrichtenController.prototype.print = function () {
                var areas = document.getElementsByName('printableAreas');
                var winPrint = window.open('', '', 'left=0,top=0,width=800,height=600,toolbar=0,scrollbars=0,status=0');
                for (var i = 0; i < areas.length; i++) {
                    winPrint.document.write(areas[i].innerHTML);
                    console.log(this.shownMessage.recipients.length);
                    if (this.shownMessage.recipients.length === 0) {
                        winPrint.document.getElementById('recipients').remove();
                    }
                    ;
                    winPrint.document.getElementById('buttons').remove();
                    if (this.shownMessage.attachments.length === 0) {
                        winPrint.document.getElementById('mailattachments').remove();
                    }
                    if (i % 2 == 1)
                        winPrint.document.write("<br /><br />");
                }
                winPrint.document.close();
                winPrint.focus();
                winPrint.print();
                winPrint.close();
            };
            NachrichtenController.prototype.getAnswerString = function (data) {
                var date = this.$qui.createDateFromString(data.dateCreated);
                var answer = '<br /> <br /> <small>' + data.sender;
                answer += " " + "schrieb am:" + " ";
                answer += date.toLocaleDateString();
                answer += " " + "um:" + " ";
                answer += date.getHours() + ":" + (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
                answer += "</small><p>" + data.messageText + "</p>";
                return answer;
            };
            NachrichtenController.prototype.renderMessageHTML = function (htmlString) {
                $(".mail-text-area").html(htmlString);
            };
            NachrichtenController.prototype.openNewMessage = function () {
                this.resetNewForm();
                this.isNewMessage = true;
                $("#newMessageBox").focus();
            };
            NachrichtenController.prototype.cancelNewMessage = function () {
                this.resetNewForm();
                this.isNewMessage = false;
            };
            NachrichtenController.prototype.resetMessageList = function () {
                this.messageList = { items: [], paginationInfo: { totalItemsCount: 0, totalPages: 0 } };
            };
            NachrichtenController.prototype.resetNewForm = function () {
                $('#summernoteNewMessage').find('.note-editable').html('');
                this.newForm = { messageText: '', recipientIds: [], subject: "", attachments: [] };
                this.uploads = [];
                this.selectedFileNames = [];
                this.currentDraftId = undefined;
                this.isDraftPosting = false;
                this.recs.forEach(function (x) { return x.isSelected = false; });
            };
            NachrichtenController.prototype.updateFlatFolderList = function () {
                this.flatFolderList = this.getFlatFolderList();
            };
            NachrichtenController.prototype.getFolders = function () {
                var _this = this;
                this.folderList = [];
                this.nachrichtenService.getFolderList().then(function (data) {
                    _this.folderList = data;
                    _this.updateFlatFolderList();
                    if (_this.$stateParams.folderId === undefined) {
                        _this.selectedFolderId = QMC.Common.Constants.MESSAGE_INBOX_FOLDER_ID;
                        _this.selectedFolderName = _this.lng.translate(21004022, "Posteingang");
                    }
                    else {
                        for (var i = 0; i < _this.folderList.length; i++) {
                            if (data[i].id === _this.$stateParams.folderId || data[i].id === _this.$stateParams.folderId) {
                                _this.changeFolder(data[i]);
                                break;
                            }
                        }
                    }
                    _this.$qui.functionWaiter("ui.createFolderForm", _this);
                    _this.$qui.functionWaiter("ui.createFolderUpdateForm", _this);
                    _this.getDrafts();
                });
            };
            NachrichtenController.prototype.updateFolderList = function () {
                var _this = this;
                this.nachrichtenService.getFolderList().then(function (data) {
                    _this.folderList = data;
                    _this.updateFlatFolderList();
                    setTimeout(function () {
                        $('#' + _this.selectedFolderId).addClass('active-folder');
                        _this.$scope.apply;
                    }, 500);
                });
            };
            NachrichtenController.prototype.getFlatFolderList = function () {
                var result = [];
                this.folderListGeneratorRecursive(this.folderList, result);
                return result;
            };
            NachrichtenController.prototype.folderListGeneratorRecursive = function (data, result) {
                if (!data)
                    return;
                for (var i = 0; i < data.length; i++) {
                    result.push(data[i]);
                    if (data[i].children.length > 0)
                        this.folderListGeneratorRecursive(data[i].children, result);
                }
            };
            NachrichtenController.prototype.getShownMessageById = function (id) {
                var _this = this;
                this.reply = false;
                this.forward = false;
                this.nachrichtenService.getMessage(id).then(function (data) {
                    _this.shownMessage = data;
                    setTimeout(function () {
                        _this.$qui.anonAvatar();
                    }, 300);
                });
            };
            NachrichtenController.prototype.markMessageAsRead = function (messageId) {
                for (var msg in this.messageList.items) {
                    if (this.messageList.items[msg].messageId === messageId) {
                        this.messageList.items[msg].isRead = true;
                    }
                }
            };
            NachrichtenController.prototype.strip = function (html) {
                if (!html)
                    return "";
                var textEl = document.createElement("div");
                textEl.innerHTML = html;
                return textEl.textContent.trim();
            };
            NachrichtenController.prototype.getMessagesOfCurrentFolder = function (page) {
                var _this = this;
                if (this.selectedFolderId === this.draftFolderId) {
                    this.messageList = {
                        paginationInfo: {
                            totalPages: 1,
                            totalItemsCount: this.drafts.length
                        },
                        items: this.drafts.filter(function (x) { return x.lastUpdate >= moment(_this.filter.filterDateFrom).startOf('day').toDate() && x.lastUpdate <= moment(_this.filter.filterDateTo).endOf('day').toDate(); }).map(function (x) { return ({
                            id: x.id,
                            objectId: x.id,
                            messageId: x.id,
                            messageObjectId: x.id,
                            folderObjectId: _this.draftFolderId,
                            senderObjectId: $('#session').data().personId,
                            sender: x.content.subject,
                            subject: _this.strip(x.content.text),
                            previewText: '',
                            isRead: true,
                            hasDocuments: false,
                            isSelected: false,
                            createdDate: x.lastUpdate
                        }); })
                    };
                    this.folderLoading = false;
                    return;
                }
                if (page === undefined || page === null) {
                    page = 0;
                }
                this.loading = true;
                this.readMode = true;
                this.resetMessageList();
                this.nachrichtenService.getMessageList(this.filter.filterDateFrom, this.filter.filterDateTo, this.selectedFolderId, page, -1).then(function (data) {
                    _this.messageList = data;
                    if (_this.$stateParams.messageId !== undefined) {
                        setTimeout(_this.$qui.anonAvatar, 350);
                        _this.showMessage(_this.$stateParams.messageId);
                        _this.markMessageAsRead(_this.$stateParams.messageId);
                    }
                    else {
                        if (_this.messageList.items.length > 1) {
                            setTimeout(_this.$qui.anonAvatar, 350);
                            if (_this.isInit === false || _this.messageList.items[0].isRead) {
                                // on the first load of the message module, just show the message, do not mark it as read
                                _this.showMessage(_this.messageList.items[0].messageObjectId);
                                _this.markMessageAsRead(_this.messageList.items[0].messageObjectId);
                            }
                        }
                        else {
                            _this.loading = false;
                        }
                    }
                    _this.loading = false;
                    _this.folderLoading = false;
                    _this.isInit = false;
                });
            };
            NachrichtenController.prototype.viewMode = function () {
                this.readMode = !this.readMode;
                if (!this.readMode)
                    setTimeout(function () { $("#mail-subject").focus(); }, 350);
            };
            NachrichtenController.prototype.getAvailableRecipients = function () {
                var _this = this;
                this.availableRecipients = [];
                this.nachrichtenService.getAvailableRecipients().then(function (data) {
                    //for (const re in data) data[re].isSelected = false;
                    data.forEach(function (x) { return (x.isSelected = false, x.displayTitle = _this.$qui.createPersonDisplay(x.lastName, x.firstName, x.shortCaption, x.personNumber)); });
                    _this.recs = data;
                    _this.availableRecipients = data.map(function (x) { return ({ text: x.displayTitle, value: x.objectId, subText: x.institute }); });
                });
            };
            NachrichtenController.prototype.markSelectedMessagesAsRead = function () {
                this.getSelectedMessages();
                if (this.selectedFolderId === undefined) {
                    this.selectedFolderId = QMC.Common.Constants.MESSAGE_INBOX_FOLDER_ID;
                }
                var request = {
                    id: null,
                    folderId: this.selectedFolderId,
                    messageIds: this.selectedMessageIds,
                    objectId: null
                };
                this.nachrichtenService.markMessageAsRead(request);
                this.$state.go(this.$state.current, { folderId: this.selectedFolderId }, { reload: true });
            };
            NachrichtenController.prototype.markShownMessageAsRead = function () {
                var _this = this;
                var request = {
                    id: null,
                    folderId: this.shownMessage.folderId,
                    messageIds: [this.shownMessage.objectId],
                    objectId: null
                };
                this.nachrichtenService.markMessageAsRead(request).then(function () {
                    // For keeping the unread messages count on folders fresh
                    _this.updateFolderList();
                });
            };
            NachrichtenController.prototype.deleteSelectedMessages = function () {
                var _this = this;
                if (this.selectedFolderId === this.draftFolderId) {
                    this.deleteDrafts(this.selectedMessageIds);
                    this.openDraftFolder();
                }
                else if (this.selectedFolderId === QMC.Common.Constants.MESSAGE_RECYCLEBIN_FOLDER_ID || !this.useTrash) {
                    var completed_1 = [];
                    var _loop_1 = function (i) {
                        completed_1.push(false);
                        this_1.nachrichtenService.deleteMessage(this_1.selectedMessageIds[i]).then(function () {
                            completed_1[i] = true;
                            if (_this.allTrueInArray(completed_1)) {
                                _this.$state.go(_this.$state.current, { folderId: _this.selectedFolderId }, { reload: true });
                                _this.$qui.notify(_this.$qui.deleteNote);
                            }
                        });
                    };
                    var this_1 = this;
                    for (var i = 0; i < this.selectedMessageIds.length; i++) {
                        _loop_1(i);
                    }
                }
                else {
                    this.moveSelectedMessagesToFolder(QMC.Common.Constants.MESSAGE_RECYCLEBIN_FOLDER_ID);
                }
            };
            NachrichtenController.prototype.allTrueInArray = function (list) {
                for (var i = 0; i < list.length; i++)
                    if (!list[i])
                        return false;
                return true;
            };
            NachrichtenController.prototype.deleteMessage = function (id) {
                var _this = this;
                if (this.selectedFolderId === QMC.Common.Constants.MESSAGE_RECYCLEBIN_FOLDER_ID || !this.useTrash) {
                    this.nachrichtenService.deleteMessage(id).then(function () {
                        _this.$state.go(_this.$state.current, { folderId: _this.selectedFolderId }, { reload: true });
                    });
                }
                else if (this.selectedFolderId === QMC.Common.Constants.MESSAGE_SENT_FOLDER_ID) {
                    this.nachrichtenService.deleteMessage(id, true).then(function () {
                        _this.$state.go(_this.$state.current, { folderId: _this.selectedFolderId }, { reload: true });
                    });
                }
                else {
                    this.moveMessageToFolder(id, QMC.Common.Constants.MESSAGE_RECYCLEBIN_FOLDER_ID);
                }
            };
            NachrichtenController.prototype.moveSelectedMessagesToFolder = function (folderId) {
                var _this = this;
                this.getSelectedMessages();
                var updateItems = [];
                for (var i = 0; i < this.selectedMessageIds.length; i++) {
                    updateItems.push({
                        folderId: this.selectedFolderId,
                        messageId: this.selectedMessageIds[i]
                    });
                }
                var request = {
                    id: null,
                    messages: updateItems,
                    targetFolderId: folderId,
                    objectId: null
                };
                this.nachrichtenService.moveMessageToFolder(request).then(function () {
                    $('#transferMailsModal').modal('hide');
                    setTimeout(function () { _this.$state.go(_this.$state.current, { folderId: _this.selectedFolderId }, { reload: true }); }, 400);
                });
            };
            NachrichtenController.prototype.moveMessageToFolder = function (messageId, folderId) {
                var _this = this;
                var messages = [];
                messages.push({
                    folderId: this.selectedFolderId,
                    messageId: messageId
                });
                var request = {
                    id: null,
                    messages: messages,
                    targetFolderId: folderId,
                    objectId: null
                };
                this.nachrichtenService.moveMessageToFolder(request).then(function () {
                    setTimeout(function () { _this.$state.go(_this.$state.current, { folderId: _this.selectedFolderId }, { reload: true }); }, 400);
                });
            };
            NachrichtenController.prototype.sendNewMessage = function () {
                var _this = this;
                if (this.selectedRecs.length <= 0)
                    return;
                // Attach the attachments to the attached attachment-object
                var attachments = [];
                for (var i = 0; i < this.selectedFileNames.length; i++) {
                    var attachment = { fileName: this.selectedFileNames[i], attachmentBase64String: this.uploads[i] };
                    attachments.push(attachment);
                }
                this.newForm.attachments = attachments;
                this.newForm.messageText = $('#summernoteNewMessage').find('.note-editable').html();
                this.loading = true;
                this.nachrichtenService.postMessage(this.newForm).then(function (e) {
                    $('#loadingScreen').modal('hide');
                    _this.loading = false;
                    // Force backdrop to go away
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                    if (e !== (null || undefined)) {
                        if (_this.currentDraftId)
                            _this.deleteDrafts([_this.currentDraftId]);
                        if (_this.selectedFolderId === _this.draftFolderId)
                            _this.openDraftFolder();
                        else
                            _this.$state.go(_this.$state.current, { folderId: _this.selectedFolderId }, { reload: true });
                    }
                }).catch(function () {
                    $('#loadingScreen').modal('hide');
                    _this.loading = false;
                });
            };
            NachrichtenController.prototype.sendAnswer = function () {
                var _this = this;
                var createData = { messageText: null, recipientIds: null, subject: null, attachments: null };
                // Attach the attachments to the attached attachment-object
                var attachments = [];
                for (var i = 0; i < this.selectedFileNames.length; i++) {
                    var attachment = { fileName: this.selectedFileNames[i], attachmentBase64String: this.uploads[i] };
                    attachments.push(attachment);
                }
                createData.attachments = attachments;
                createData.recipientIds = [];
                if (this.replyToAll === true) {
                    for (var i = 0; i < this.shownMessage.recipients.length; i++) {
                        createData.recipientIds.push(this.shownMessage.recipients[i].recipientObjectId);
                    }
                }
                else {
                    createData.recipientIds.push(this.shownMessage.senderObjectId);
                }
                createData.subject = this.lng.translate(21004048, 'AW') + ": " + this.shownMessage.subject;
                createData.messageText = $('#summernoteAnswerMessage').find('.note-editable').html();
                this.loading = true;
                this.nachrichtenService.postMessage(createData).then(function () {
                    _this.deleteDrafts([_this.currentDraftId]);
                    $('#loadingScreen').modal('hide');
                    _this.loading = false;
                    // Force backdrop to go away
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                    _this.$state.go(_this.$state.current, { folderId: _this.selectedFolderId }, { reload: true });
                });
            };
            NachrichtenController.prototype.changeReplyMode = function (mode) {
                var _this = this;
                this.uploads = [];
                this.selectedFileNames = [];
                if (mode === 'replyToAll') {
                    this.forward = false;
                    this.reply = false;
                    var draft = this.drafts.filter(function (x) { return x.internalMessageId === _this.shownMessage.objectId; })[0];
                    if (draft) {
                        this.currentDraftId = draft.id;
                        $('#summernoteAnswerMessage').find('.note-editable').html(draft.content.text);
                    }
                }
                if (mode === 'reply') {
                    this.forward = false;
                    this.replyToAll = false;
                    var draft = this.drafts.filter(function (x) { return x.internalMessageId === _this.shownMessage.objectId; })[0];
                    if (draft) {
                        this.currentDraftId = draft.id;
                        $('#summernoteAnswerMessage').find('.note-editable').html(draft.content.text);
                    }
                }
                if (mode === 'forward') {
                    this.reply = false;
                    if (this.forward) {
                        this.forwardRecipients = [];
                        this.selectedFileNames = this.shownMessage.attachments.map(function (x) {
                            return x.caption && x.caption.length > 0 ? x.caption : x.fileName;
                        });
                        this.uploads = this.shownMessage.attachments.map(function (x) { return 'fwrd;' + x.parentObjectId + ';' + x.objectId; });
                        var draft = this.drafts.filter(function (x) { return x.internalMessageId === _this.shownMessage.objectId; })[0];
                        if (draft) {
                            this.currentDraftId = draft.id;
                            this.forwardRecipients = draft.content.recipientIds;
                            $('#summernoteForwardMessage').find('.note-editable').html(draft.content.text);
                        }
                    }
                }
            };
            NachrichtenController.prototype.sendForward = function () {
                var _this = this;
                var createData = { messageText: null, recipientIds: null, subject: null, attachments: null };
                // Attach the attachments to the attached attachment-object
                var attachments = [];
                for (var i = 0; i < this.selectedFileNames.length; i++) {
                    var attachment = { fileName: this.selectedFileNames[i], attachmentBase64String: this.uploads[i] };
                    attachments.push(attachment);
                }
                createData.attachments = attachments;
                createData.recipientIds = this.forwardRecipients;
                createData.subject = this.lng.translate(21004049, 'WG') + ": " + this.shownMessage.subject;
                createData.messageText = $('#summernoteForwardMessage').find('.note-editable').html();
                this.loading = true;
                this.nachrichtenService.postMessage(createData).then(function () {
                    _this.deleteDrafts([_this.currentDraftId]);
                    $('#loadingScreen').modal('hide');
                    _this.loading = false;
                    // Force backdrop to go away
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                    _this.$state.go(_this.$state.current, { folderId: _this.selectedFolderId }, { reload: true });
                });
            };
            NachrichtenController.prototype.getAttachment = function (message, attachmentId) {
                var _this = this;
                if (message.attachments !== undefined && message.attachments !== null && message.attachments.length > 0) {
                    this.loadingAttachement = true;
                    $('#previewModal').modal('show');
                    this.nachrichtenService.downloadAttachment(message.attachments[0].parentObjectId, attachmentId).then(function (data) {
                        try {
                            // Find filename from mail attachments
                            var filename = 'datei';
                            for (var i = 0; i < message.attachments.length; i++) {
                                if (message.attachments[i].objectId === attachmentId) {
                                    filename = message.attachments[i].fileName;
                                }
                            }
                            // get filename suffix and contenttype
                            var temp = filename.split('.');
                            var ext = temp[temp.length - 1];
                            _this.fileInfos = {
                                base64: data,
                                fileType: ext,
                                fileName: filename
                            };
                            _this.loadingAttachement = false;
                            _this.$qui.scopeApply(_this.$scope);
                        }
                        catch (e) {
                            console.log(e);
                            _this.loadingAttachement = false;
                        }
                    });
                }
            };
            NachrichtenController.prototype.getAllAttachments = function (message) {
                var _this = this;
                if (message.attachments !== undefined && message.attachments !== null && message.attachments.length > 0) {
                    this.nachrichtenService.downloadAttachment(message.attachments[0].parentObjectId).then(function (data) {
                        try {
                            var filename = 'anhang.zip';
                            var contentType = 'application/zip';
                            _this.$qui.notify(_this.$qui.downloadNote);
                            var linkElement = document.createElement('a');
                            var blob = _this.base64ToBlob(data, contentType);
                            var url = window.URL.createObjectURL(blob);
                            linkElement.setAttribute('href', url);
                            linkElement.setAttribute('download', filename);
                            var clickEvent = new MouseEvent('click', {
                                "view": window,
                                "bubbles": true,
                                "cancelable": false
                            });
                            linkElement.dispatchEvent(clickEvent);
                        }
                        catch (e) {
                            console.log(e);
                        }
                    });
                }
            };
            NachrichtenController.prototype.base64ToBlob = function (base64Data, contentType) {
                contentType = contentType || '';
                var sliceSize = 1024;
                var byteCharacters = atob(base64Data);
                var bytesLength = byteCharacters.length;
                var slicesCount = Math.ceil(bytesLength / sliceSize);
                var byteArrays = new Array(slicesCount);
                for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
                    var begin = sliceIndex * sliceSize;
                    var end = Math.min(begin + sliceSize, bytesLength);
                    var bytes = new Array(end - begin);
                    for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
                        bytes[i] = byteCharacters[offset].charCodeAt(0);
                    }
                    byteArrays[sliceIndex] = new Uint8Array(bytes);
                }
                return new Blob(byteArrays, { type: contentType });
            };
            NachrichtenController.prototype.openFileSelector = function () {
                var fileSelector = angular.element('#fileselect');
                fileSelector.click();
            };
            NachrichtenController.prototype.removeSelectedFile = function (index) {
                this.selectedFileNames.splice(index, 1);
                this.uploads.splice(index, 1);
            };
            NachrichtenController.prototype.getPagesCount = function (count) {
                return new Array(count);
            };
            NachrichtenController.prototype.getFolderListForCreate = function () {
                return this.flatFolderList.map(function (obj) { return ({ value: obj.folderId, text: obj.caption }); });
            };
            NachrichtenController.prototype.getFolderListForUpdate = function () {
                var _this = this;
                if (!this.flatFolderList || !this.selectedFolder)
                    return [];
                return this.flatFolderList.filter(function (obj) { return (obj.folderId !== _this.selectedFolder.folderId) && !_this.isChild(_this.selectedFolder.children, obj.folderId); })
                    .map(function (obj) { return ({ value: obj.folderId, text: obj.caption }); });
            };
            NachrichtenController.prototype.isChild = function (folders, folderId) {
                for (var i = 0; i < folders.length; i++) {
                    var child = folders[i];
                    if (child.folderId === folderId) {
                        return true;
                    }
                    return this.isChild(child.children, folderId);
                }
            };
            NachrichtenController.prototype.createFolder = function () {
                var _this = this;
                this.folderFormCreate.order = this.getFolderOrder(this.folderFormCreate.parentFolderId);
                this.nachrichtenService.postFolder(this.folderFormCreate)
                    .then(function () {
                    _this.getFolders();
                });
            };
            NachrichtenController.prototype.getFolderOrder = function (parentId) {
                var folderOrder = 1;
                for (var i = 0; i < this.folderList.length; i++) {
                    var folder = this.folderList[i];
                    if (folder.folderId === parentId) {
                        if (folder.children.length > 0)
                            folderOrder = folder.children.length;
                        break;
                    }
                }
                return folderOrder;
            };
            NachrichtenController.prototype.updateFolder = function () {
                var _this = this;
                this.nachrichtenService.putFolder(this.selectedFolder.folderId, this.folderFormUpdate)
                    .then(function () {
                    _this.getFolders();
                });
            };
            NachrichtenController.prototype.deleteFolder = function () {
                var _this = this;
                QMC.Common.Utilities.confirm(this.promptOptionsFolderDelete, function (data) {
                    if (data) {
                        _this.nachrichtenService.deleteFolder(_this.selectedFolder.folderId)
                            .then(function () {
                            _this.getFolders();
                        });
                        $('#folderModalUpdate').modal('hide');
                    }
                    else {
                        location.hash = '/mailbox';
                    }
                });
            };
            NachrichtenController.prototype.isStandardFolder = function () {
                if (this.selectedFolder === (null || undefined))
                    return true;
                return this.selectedFolder.id === QMC.Common.Constants.MESSAGE_INBOX_FOLDER_ID ||
                    this.selectedFolder.id === QMC.Common.Constants.MESSAGE_RECYCLEBIN_FOLDER_ID ||
                    this.selectedFolder.id === QMC.Common.Constants.MESSAGE_SENT_FOLDER_ID ||
                    this.selectedFolder.id === this.draftFolderId;
            };
            ////////////////////// DRAFTS //////////////////////
            NachrichtenController.prototype.newMessageDraft = function (content) {
                var _this = this;
                if (!this.currentDraftId)
                    this.setDraft({
                        content: {
                            text: content,
                            recipientIds: this.newForm.recipientIds,
                            subject: this.newForm.subject
                        },
                        lastUpdate: new Date()
                    });
                else {
                    var draft = this.drafts.filter(function (x) { return x.id === _this.currentDraftId; })[0];
                    draft.content = {
                        text: content,
                        recipientIds: this.newForm.recipientIds,
                        subject: this.newForm.subject
                    };
                    this.setDraft(draft);
                }
            };
            NachrichtenController.prototype.forwardMessageDraft = function (content) {
                this.existingMessageDraft(content, this.forwardRecipients, this.lng.translate(21004049, 'WG') + ": " + this.shownMessage.subject);
            };
            NachrichtenController.prototype.replyMessageDraft = function (content) {
                var recipients = [this.shownMessage.senderObjectId];
                if (this.replyToAll) {
                    this.shownMessage.recipients.forEach(function (x) { return recipients.push(x.recipientObjectId); });
                }
                this.existingMessageDraft(content, recipients, this.lng.translate(21004048, 'AW') + ": " + this.shownMessage.subject);
            };
            NachrichtenController.prototype.existingMessageDraft = function (content, recipients, subject) {
                var _this = this;
                var present = this.drafts.filter(function (x) { var _a; return x.internalMessageId === ((_a = _this.shownMessage) === null || _a === void 0 ? void 0 : _a.objectId); })[0];
                if (present) {
                    present.content = {
                        subject: subject,
                        recipientIds: recipients,
                        text: content
                    };
                    this.setDraft(present);
                }
                else {
                    this.setDraft({
                        content: {
                            recipientIds: recipients,
                            subject: subject,
                            text: content
                        },
                        lastUpdate: new Date(),
                        internalMessageId: this.shownMessage.objectId
                    });
                }
            };
            NachrichtenController.prototype.openDraftFolder = function () {
                var folder = {
                    mailboxFolderWvId: this.draftFolderId,
                    caption: 'Entwurf',
                    isFixed: true,
                    order: 1000,
                    unreadCount: this.drafts.length,
                    folderId: this.draftFolderId,
                    children: [],
                    id: this.draftFolderId,
                    objectId: this.draftFolderId
                };
                this.readMode = true;
                this.changeFolder(folder);
                this.ui.toState(2);
            };
            NachrichtenController.prototype.openDraft = function (id) {
                var draft = this.drafts.filter(function (x) { return x.id === id; })[0];
                if (!draft)
                    return;
                this.lastDraftSave = undefined;
                this.resetNewForm();
                this.currentDraftId = draft.id;
                this.newForm = {
                    attachments: [],
                    messageText: draft.content.text,
                    recipientIds: draft.content.recipientIds,
                    subject: draft.content.subject
                };
                var _loop_2 = function (rec) {
                    rec.isSelected = draft.content.recipientIds.some(function (x) { return x === rec.objectId; });
                };
                // Select recipients
                for (var _i = 0, _a = this.recs; _i < _a.length; _i++) {
                    var rec = _a[_i];
                    _loop_2(rec);
                }
                this.recSelect();
                this.viewMode();
                this.ui.toState(2);
                this.$qui.bindEvents();
                $('#summernoteNewMessage').find('.note-editable').html(draft.content.text);
            };
            NachrichtenController.prototype.getDrafts = function () {
                var _this = this;
                this.nachrichtenService.getDrafts().then(function (data) {
                    _this.drafts = data;
                }).catch(function () {
                    _this.drafts = [];
                });
            };
            NachrichtenController.prototype.deleteDrafts = function (ids) {
                var _this = this;
                ids.forEach(function (id) {
                    if (!id)
                        return;
                    _this.drafts = _this.drafts.filter(function (x) { return x.id !== id; });
                    _this.nachrichtenService.deleteDraft(id);
                });
                this.lastDraftSave = undefined;
                this.currentDraftId = undefined;
                if (this.selectedFolderId === this.draftFolderId) {
                    this.setFilterView('hide', 140);
                }
            };
            NachrichtenController.prototype.setDraft = function (data) {
                var _this = this;
                if (this.isDraftPosting) {
                    setTimeout(function () {
                        _this.setDraft(data);
                    }, 500);
                    return;
                }
                data.lastUpdate = new Date();
                if (!this.currentDraftId) {
                    if (this.draftIsEmpty(data))
                        return;
                    this.isDraftPosting = true;
                    this.nachrichtenService.postDraft(data).then(function (e) {
                        _this.currentDraftId = e;
                        _this.isDraftPosting = false;
                        data.id = e;
                        _this.drafts.push(data);
                    });
                }
                else {
                    if (this.draftIsEmpty(data)) {
                        this.deleteDrafts([this.currentDraftId]);
                    }
                    else {
                        data.id = this.currentDraftId;
                        this.drafts = this.drafts.filter(function (x) { return x.id !== _this.currentDraftId; });
                        this.drafts.push(data);
                        if (!this.lastDraftSave) {
                            this.lastDraftSave = data;
                            setTimeout(function () {
                                if (!_this.currentDraftId || !_this.lastDraftSave)
                                    return;
                                _this.nachrichtenService.putDraft(_this.currentDraftId, _this.lastDraftSave);
                                _this.lastDraftSave = undefined;
                            }, 5000);
                        }
                        else {
                            this.lastDraftSave = data;
                        }
                    }
                }
            };
            NachrichtenController.prototype.draftIsEmpty = function (draft) {
                return draft.content.recipientIds.length === 0
                    && draft.content.subject.length === 0
                    && this.strip(draft.content.text).length === 0;
            };
            NachrichtenController = __decorate([
                QMC.Controller('QMC.Nachrichten', 'NachrichtenController'),
                QMC.Inject('$location', 'NachrichtenService', '$qui', '$stateParams', '$state', '$scope', 'QmcLanguageService', 'UserService')
            ], NachrichtenController);
            return NachrichtenController;
        }());
    })(InternalMessage = QMC.InternalMessage || (QMC.InternalMessage = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var InternalMessage;
    (function (InternalMessage) {
        var UserInterface = /** @class */ (function (_super) {
            __extends(UserInterface, _super);
            function UserInterface() {
                var _this = _super.call(this) || this;
                _this.state = 0;
                _this.mobile = _super.prototype.isMobile.call(_this);
                /**
                 * Folder form
                 * @memberOf UserInterface
                 */
                _this.folderForm = {
                    form: [
                        {
                            label: "Name",
                            placeholder: "Name",
                            type: "String",
                            lngTag: "20000072",
                            required: true,
                            model: "name",
                            validate: {
                                message: "Bitte den Ordnernamen angeben.",
                                messageTag: "21004036"
                            },
                            style: {
                                class: "col-xs-6"
                            }
                        },
                        {
                            label: "Parentordner",
                            placeholder: "Parentordner",
                            type: "Select",
                            lngTag: "21004037",
                            required: true,
                            model: "parentFolderId",
                            dataSource: "getFolderListForCreate",
                            validate: {
                                message: "Bitte den �bergeordneten Ordner ausw�hlen",
                                messageTag: "21004038",
                            },
                            style: {
                                class: "col-xs-6"
                            }
                        }
                    ],
                    actions: {
                        post: "createFolder"
                    }
                };
                _this.folderFormUpdate = {
                    form: [
                        {
                            label: "Name",
                            placeholder: "Name",
                            type: "String",
                            lngTag: "20000072",
                            required: true,
                            model: "name",
                            validate: {
                                message: "Bitte den Ordnernamen angeben.",
                                messageTag: "21004036"
                            },
                            style: {
                                class: "col-xs-4"
                            }
                        },
                        {
                            label: "Parentordner",
                            placeholder: "Parentordner",
                            type: "Select",
                            lngTag: "21004037",
                            required: true,
                            model: "parentFolderId",
                            dataSource: "getFolderListForUpdate",
                            validate: {
                                message: "Bitte den �bergeordneten Ordner ausw�hlen",
                                messageTag: "21004038",
                            },
                            style: {
                                class: "col-xs-4"
                            }
                        },
                        {
                            label: "Reihenfolge",
                            placeholder: "Reihenfolge",
                            type: "String",
                            lngTag: "21004039",
                            required: true,
                            model: "order",
                            validate: {
                                message: "Bitte die Reihenfolge angeben.",
                                messageTag: "21004040"
                            },
                            style: {
                                class: "col-xs-4"
                            }
                        }
                    ],
                    actions: {
                        put: "updateFolder",
                        delete: "deleteFolder"
                    }
                };
                _this.onMobile();
                _this.onDesktop();
                return _this;
            }
            UserInterface.prototype.onDesktop = function () {
                if (_super.prototype.isMobile.call(this))
                    return;
            };
            UserInterface.prototype.onMobile = function () {
                if (!_super.prototype.isMobile.call(this))
                    return;
                this.initStates();
            };
            UserInterface.prototype.initStates = function () {
                $("[data-state]").each(this.initState);
            };
            // tslint:disable-next-line:no-unused-variable
            UserInterface.prototype.toState = function (state) {
                if (!_super.prototype.isMobile.call(this))
                    return;
                var vm = this;
                vm.state = state;
                console.log("Go To State", state);
                $("[data-state]").each(function (index) {
                    ($(this).data().state === vm.state) ? $(this).show() : $(this).hide();
                    if (vm.state > 1)
                        $("[data-state=\"1\"]").show();
                });
            };
            UserInterface.prototype.initState = function (index) {
                var data = $(this).data();
                $(this).addClass("mobile-fullscreen");
                if (data.state !== 0)
                    $(this).hide();
            };
            return UserInterface;
        }(QMC.Common.UserInterface));
        InternalMessage.UserInterface = UserInterface;
    })(InternalMessage = QMC.InternalMessage || (QMC.InternalMessage = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../../maps/Nachrichten/qmc.nachrichten.js.map
